import {
  Collapse,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import List from "@mui/material/List";
import { useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import ArrowMenu from "../../components/IconsSvg/ArrowMenu";

const DrawerMenuItems = props => {
  const { name, href, icon, submenu = [], toggleDrawer } = props;
  const { locale } = useRouter();
  const router = useRouter();

  const isExpandable = submenu?.length > 0;
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(!open);
  };

  const MenuItemRoot = !submenu.length ? (
    <Link href={href} locale={locale}>
      <ListItemButton
        component="a"
        onClick={e => toggleDrawer(false)(e)}
        className={router.asPath === href ? "active" : ""}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={name} />
      </ListItemButton>
    </Link>
  ) : (
    <ListItemButton onClick={handleClick}>
      <ListItemIcon>
        {isExpandable && !open && <ArrowMenu />}
        {isExpandable && open && <ArrowMenu className={"open"} />}
      </ListItemIcon>
      <ListItemText primary={name} />
    </ListItemButton>
  );

  const MenuItemChildren = isExpandable ? (
    <Collapse in={open} timeout="auto" unmountOnExit>
      <List component="ul" disablePadding>
        {submenu.map((item, index) => (
          <DrawerMenuItems {...item} key={index} toggleDrawer={toggleDrawer} />
        ))}
      </List>
    </Collapse>
  ) : null;

  return (
    <>
      {MenuItemRoot}
      {MenuItemChildren}
    </>
  );
};

export default DrawerMenuItems;
